/**
 * TypingIndicator — Shows "Alice is typing..." with animated dots.
 *
 * Props:
 *   typingUsers: object — { uuid: displayName, ... } for the current conversation
 *   currentUserUuid: string — exclude self from display
 */
const TypingIndicator = ({ typingUsers = {}, currentUserUuid = "" }) => {
  // Filter out the current user
  const others = Object.entries(typingUsers).filter(
    ([uuid]) => uuid !== currentUserUuid,
  );

  if (others.length === 0) return null;

  let text;
  if (others.length === 1) {
    text = `${others[0][1]} is typing`;
  } else if (others.length === 2) {
    text = `${others[0][1]} and ${others[1][1]} are typing`;
  } else {
    text = "Several people are typing";
  }

  return (
    <div className="flex items-center gap-x-2 px-4 py-1.5 min-h-[28px]">
      <span className="text-[12px] text-zinc-400 dark:text-zinc-500 italic">
        {text}
      </span>
      <span className="flex gap-x-0.5">
        <span
          className="w-1 h-1 rounded-full bg-zinc-400 dark:bg-zinc-500 animate-bounce"
          style={{ animationDelay: "0ms", animationDuration: "1s" }}
        />
        <span
          className="w-1 h-1 rounded-full bg-zinc-400 dark:bg-zinc-500 animate-bounce"
          style={{ animationDelay: "150ms", animationDuration: "1s" }}
        />
        <span
          className="w-1 h-1 rounded-full bg-zinc-400 dark:bg-zinc-500 animate-bounce"
          style={{ animationDelay: "300ms", animationDuration: "1s" }}
        />
      </span>
    </div>
  );
};

export default TypingIndicator;
